/**
 * Truncamento das listas das células Responsável/Área do Resumo (pedido 08/09:
 * "como são muitos retornos, apresentar poucas e depois '…'").
 *
 * Puro e testável, fora do componente (mesma família dos demais utils desta
 * pasta): devolve os até `max` primeiros itens e a flag de truncamento. Quem
 * exibe anexa o reticências quando `truncado` e põe a lista COMPLETA no `title`
 * da célula — o tooltip nunca perde informação.
 *
 * Genérico (pedido 08/09, pareamento área↔responsável): o truncamento passou a
 * ser por PARES — o item pode ser string ou o par `{ area, responsavel }`, a
 * regra de corte é a mesma.
 */

export interface ListaResumida<T> {
  /** Os até `max` primeiros itens, na ordem recebida. */
  visiveis: T[];
  /** Havia mais itens do que `max`? (quem exibe anexa o "…") */
  truncado: boolean;
}

export const resumirLista = <T>(itens: T[], max = 2): ListaResumida<T> => ({
  visiveis: itens.slice(0, Math.max(0, max)),
  truncado: itens.length > Math.max(0, max),
});
